import {ApiTags} from '@nestjs/swagger';
import { Controller, Post, Body, Req } from '@nestjs/common';
import { QualificationDTO } from './dto/qualifications.dto';
import {ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import {AllQualificationsResponse, QualificationsResponse} from '@gtpl/shared-models/masters';
import { QualificationsRequest } from './dto/qualifications.request';
import { QualificationService } from './qualifications.service';
//service

@ApiTags('Qualifications')
@Controller('qualifications')
export class QualificationController {
    constructor(
        private qualificationService: QualificationService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}
    @Post('/createQualification')
    async createQualification(@Body() qDTO: QualificationDTO, isUpdate: boolean = false): Promise<QualificationsResponse>{
    try{
        return await this.qualificationService.createQualification(qDTO, false);        
    } catch(error){
        return this.applicationExceptionHandler.returnException(QualificationsResponse, error);
    }
    } 
    @Post('/updateQualification')
    async updateQualification(@Body() qDTO: QualificationDTO, @Req() request: Request): Promise<QualificationsResponse>{
        try{
            return await this.qualificationService.createQualification(qDTO, true);        
        } catch(error){
            return this.applicationExceptionHandler.returnException(QualificationsResponse, error);
        }
        } 
    @Post('/getAllQualifications')
    async getAllQualifications() : Promise<AllQualificationsResponse> {
        try{
            return await this.qualificationService.getAllQualifications();        
        } catch(error){
            return this.applicationExceptionHandler.returnException(AllQualificationsResponse, error);
        }
    } 
    @Post('/getAllActiveQualifications')
    async getAllActiveQualifications(@Req() request: Request) : Promise<AllQualificationsResponse> {
        try{
            return await this.qualificationService.getAllActiveQualifications();        
        } catch(error){
            return this.applicationExceptionHandler.returnException(AllQualificationsResponse, error);
        }
    } 
    @Post('/activateOrDeactivateQualification')
    async activateOrDeactivateQualification(@Body() qReq: QualificationsRequest): Promise<QualificationsResponse>{
        try{
            return await this.qualificationService.activateOrDeactivateQualification(qReq);        
        } catch(error){
            return this.applicationExceptionHandler.returnException(QualificationsResponse, error);
        }
        } 
}